import script from "./MyInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyInfo.vue?vue&type=script&lang=ts&setup=true"

import "./MyInfo.vue?vue&type=style&index=0&id=17bfb0cc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17bfb0cc"]])

export default __exports__